import React from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function WinnerAssetsLanding() {
    const navigate = useNavigate();
    const [error, setError] = React.useState('');
    React.useEffect(() => {
        api.get('/admin/api/winner-assets/config').then((response) => {
            const year = response.data?.years?.[0];
            if (year) navigate(`/winner-assets/${year}`, { replace: true });
            else setError('No winner asset years are configured.');
        }).catch(() => setError('Unable to load winner asset configuration.'));
    }, [navigate]);
    if (error) return <Alert severity="error" sx={{ m: 4 }}>{error}</Alert>;
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
}